import React, { useRef, useState } from "react";
import { message, Button, Form, Input, Row, Col, Modal } from "antd";
import { addColor } from "./ColourApi";

const AddColour = ({ isOpen, setIsOpen, from, Fill, apiCall, current }) => {
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [isLoading, setIsLoading] = useState(false);
  console.log(Fill.name);
  const createColour = (changedValues) => {
    setIsLoading(true);
    let payload = {
      name: changedValues.name,
      colorCode: changedValues.colorCode,
    };
    addColor(payload)
      .then((response) => {
        if (response.data.status) {
          message.success({ content: response.data.message });
          apiCall(current);
          setIsOpen(false);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        createColour(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      footer={null}
      visible={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      title="Add Colour"
    >
      <Form
        className="bg-rgbaprimary1 p-4 mt-4"
        layout="vertical"
        onFinishFailed={(err) => console.log(err)}
        onFinish={createColour}
        form={form}
        ref={formRef}
        initialValues={
          from === "add"
            ? ""
            : {
                name: Fill.name,
              }
        }
      >
        <Row className="grid grid-cols-1">
          <Col>
            <Form.Item
              name="name"
              label="Colour Name"
              rules={[
                {
                  required: true,
                  message: "Please enter Colour name",
                },
                {
                  message: "Please enter a valid Colour name",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row className="grid grid-cols-1">
          <Col>
            <Form.Item
              name="colorCode"
              label="Colour Code"
              rules={[
                {
                  required: true,
                  message: "Please enter Colour Code",
                },
                {
                  message: "Please enter a valid Colour Code",
                },
              ]}
            >
              <Input type="color" />
            </Form.Item>
          </Col>
        </Row>
        <Row className="flex justify-between gap-4">
          <Form.Item className="mt-4">
            <Button
              className="bg-white text-rgbaprimary9  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="reset"
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item className="mt-4">
            <Button
              className="bg-primary text-white  hover:!bg-rgbaprimary8 hover:!text-white hover:!border-none"
              htmlType="submit"
            >
              {from === "add" ? "Create Colour" : "Edit Colour "}
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddColour;
